import { ComponentType } from 'react';
import { Box } from '@mui/system';
import { Button, Stack } from '@mui/material';
import { useTranslation } from 'react-i18next';
import clsx from 'clsx';
import useStyles from './styles';
import { FormikValues, useFormik } from 'formik';

interface DataTableFilterProps {
  className?: string;
  children: (formik: any) => any;
  initialValues: Record<string, any>;
  onSubmit: (values: FormikValues) => void;
}

export const DataTableExtendedFilter: ComponentType<DataTableFilterProps> = ({
  className,
  initialValues,
  onSubmit,
  children,
}) => {
  const classes = useStyles();
  const { t } = useTranslation();
  const formik = useFormik({
    initialValues: initialValues,
    onSubmit,
    validateOnBlur: false,
    validateOnChange: false,
  });

  return (
    <form
      onSubmit={formik.handleSubmit}
      action={'/'}
      method="GET"
      className={clsx(classes.root, className)}
    >
      <Stack direction="row" spacing={3} justifyContent="flex-start">
        {children(formik)}
        <Box style={{ paddingTop: 21 }}>
          <Button type="submit" variant="contained" color="secondary">
            {t('action.search', 'Найти')}
          </Button>
        </Box>
      </Stack>
    </form>
  );
};
